var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      class: _vm.componentClass,
      style: _vm.componentStyle,
      attrs: { id: _vm.id },
    },
    [
      _vm._t("title", function () {
        return [
          _c("h3", { class: _vm.titleClass }, [
            _c(
              "a",
              { staticClass: "anchor", attrs: { href: `#${_vm.id}` } },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.$v7.solid.faLinkHorizontal, size: "xs" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v('Link to "' + _vm._s(_vm.title) + '"'),
                ]),
              ],
              1
            ),
            _vm._v("\n\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
        ]
      }),
      _vm._v(" "),
      _vm._t("copy", function () {
        return [_c("p", [_vm._t("default")], 2)]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }